module.exports = __webpack_public_path__ + "img/3Y.a985d7aa.png";